"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getClassNames = void 0;

var _react = require("@fluentui/react");

var getClassNames = (0, _react.memoizeFunction)(function () {
  return {
    root: (0, _react.mergeStyles)({
      display: 'flex',
      flex: '0 0 auto'
    }),
    fill: (0, _react.mergeStyles)({
      flex: '1'
    })
  };
});
exports.getClassNames = getClassNames;